// extracted by mini-css-extract-plugin
export var pagination = "gallery-pagination-module--pagination--bOrqb";